import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import useResizeObserver from "../../hooks/use-resize-observer";
import { theme } from "../../shared/theme";

import Button from "./../button";
import logoSrc from '@assets/bws-2020-logo.svg';
import downloadSrc from '@assets/download-icon.svg';
import basketSrc from '@assets/basket-icon.svg';
import infoSrc from '@assets/info-icon.svg';
import closeSrc from '@assets/close.svg';
import pdfSrc from '@assets/BW-Stiftung_Jahresbericht_2020_Ansicht.pdf';

const Header = React.forwardRef(({ closeLink, aboutUsLink, buttons }, ref) => {

  // check client width to show / hide buttons & close icon
  const wrapperRef = useRef(null);
  const [width, setWidth] = useState(document.documentElement.clientWidth);

  const handleResize = () => {
    setWidth(document.documentElement.clientWidth);
  };

  useResizeObserver({
    callback: handleResize,
    element: wrapperRef,
  });

  return (
    <div className="header" ref={ref}>
			<div className="headerWrapper" ref={wrapperRef}>
				<Link className="headerLogo" to={{pathname: '/', state: {default: true}}} >
					<img src={logoSrc} />
				</Link>
				<div className="headerMenu">
					{ buttons &&
						(width > theme.breakpoints.lg && (
						<>
							<Button
								to={'#'}
								target="_blank"
								download
								text={`PDF herunterladen`}
								src={downloadSrc}
								color={`black`}
								handleClick={(event) => {
									event.preventDefault()
									window.open(pdfSrc)
								}}
							/>
							<Button
								to={'#'}
								target="_blank"
								text={`Magazinbestellung`}
								src={basketSrc}
								color={`black`}
								handleClick={(event) => {
									event.preventDefault()
									window.open('https://www.bwstiftung.de/de/publikation/jahresbericht-2020')
								}}
							/>
						</>
					))}
					{	aboutUsLink && (
							<Link className="headerMenuItem" to="/ueber-uns">
								{ width > theme.breakpoints.md && <span>Über uns</span>}
								<img className="headerIcon" src={infoSrc} />
							</Link>
					)}
					{	closeLink &&
						(width > theme.breakpoints.md ? (
							<Link className="headerMenuItem headerMenuItemClose" to={`/`}>
								<span>Schließen</span>
								<img src={closeSrc} />
							</Link>
						) : (
							<Link className="headerMenuItem headerMenuItemClose" to={`/`}>
								<img src={closeSrc} />
							</Link>
						))}
				</div>
			</div>
    </div>
  );
});

export default Header;
